import {
  GallectionType,
  GallectionResourceType,
} from '@wix/da-shared-react/pkg/types/gallection';

export { GallectionType, GallectionResourceType };

export enum GallectionSourceType {
  FEATURED_GALLERY = 'featured_gallery',
  NEWEST = 'newest',
  PRINTS = 'prints',
  GALLERY = 'gallery',
  COLLECTION = 'collection',
}

export enum GallectionSortOrder {
  NEWEST = 'newest',
  POPULAR = 'popular',
}
